import React, { Fragment } from 'react';

export const MenuIconButton = ({ onClick, style }) => {
    return (
        <span className="top_btn menu" onClick={ onClick } style={ style }><i className="fas fa-bars fa-lg"></i></span>
    )
}

export const MenuIconSearchButton = ({ onClick, style }) => {
    return (
        <span className="top_btn log" onClick={ onClick } style={ style }><i className="fas fa-search"></i></span>
    )
}

export const MenuIconCheckboxButton = ({ onClick, style }) => {
    return (
        <span className="top_btn log" onClick={ onClick } style={ style }><i className="far fa-check-square" style={{ fontSize: "1.1rem" }}></i></span>
    )
}

export const MenuIconDeleteGroup = ({ onClick, onCancel, style }) => {
    return (
        <Fragment>
            <span className="top_btn log negative" onClick={ onClick } style={{ width:"40px",lineHeight:"40px",fontSize:"0.75rem",fontWeight:"bold",color:"#f86c6c" }}>삭제</span>
            <span className="top_btn log" onClick={ onCancel } style={{ width:"40px",lineHeight:"40px",right:"45px",fontSize:"0.75rem",fontWeight:"bold" }}>취소</span>
        </Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/UserIconButton.js